import React from 'react';
import {View} from 'react-native';

import ProfileHeader from '/component/base/ProfileHeader';
import Text from '/component/base/Text';
import Gutter from '/component/layout/Gutter';
import {DownlineProfile} from '/constant/TestIDs';
import {generateComponentCallback} from '/util/component.util';

import {styles} from './ProfileHeaderSection.style';

interface ProfileHeaderSectionProps {
  fullName: string;
  avatarUrl: string;
  accountEmail: string;
  rankDescription: string;
  style: {base: object; title: object};
  optaviaId: number | null;
}

export const ProfileHeaderSection = ({
  fullName = '',
  avatarUrl = '',
  accountEmail = '',
  rankDescription = '',
  style = {base: {}, title: {}},
  optaviaId = null,
}: ProfileHeaderSectionProps) => (
  <View style={{...styles.base, ...style}}>
    <Gutter>
      <ProfileHeader
        title={generateComponentCallback({
          component: (
            <View style={styles.title}>
              <Text
                allowFontScaling
                maxFontSizeMultiplier={2}
                variant="small"
                emphasis="low"
                testID={DownlineProfile.rank}>
                {rankDescription}
              </Text>
            </View>
          ),
        })}
        name={`${fullName}`}
        avatarUrl={avatarUrl}
        email={accountEmail}
        isCoach={true}
        optaviaId={optaviaId}
      />
    </Gutter>
  </View>
);

export default ProfileHeaderSection;
